// src/config/blockThemes.js
const blockThemes = [
  {
    style: {
      '--theme-color': 'white',
      '--theme-high-contrast-color': 'var(--blue)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--purple)',
      '--link-foreground-color': 'var(--dark-purple)',
    },
    name: 'default',
    label: 'Default',
  },
  {
    style: {
      '--theme-color': 'var(--lightgrey)',
      '--theme-high-contrast-color': 'var(--charcoal)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--grey)',
      '--link-foreground-color': 'var(--purple)',
    },
    name: 'lightgrey',
    label: 'Light Grey',
  },
  {
    style: {
      '--theme-color': 'var(--dark-terra)',
      '--theme-high-contrast-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'dark-terra',
    label: 'Dark Terracotta',
  },
  {
    style: {
      '--theme-color': 'var(--dark-purple)',
      '--theme-high-contrast-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'dark-purple',
    label: 'Dark Purple',
  },
  {
    style: {
      '--theme-color': 'var(--charcoal)',
      '--theme-high-contrast-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'charcoal',
    label: 'Charcoal',
  },
];

export default blockThemes;
